import {
  AccountActiveTicketListResponse,
  AccountCartLifetimeResponse,
  AccountRelatedCustomersQuery,
  ApiResponse,
  EshopCustomerAccountService,
  CustomerHeaderVm,
} from '@/api';

export default {
  getAccountRelatedCustomerList: async (query: AccountRelatedCustomersQuery): Promise<CustomerHeaderVm[]> => {
    const response = await EshopCustomerAccountService.eshopCustomerAccountControllerGetAccountRelatedCustomers(query);

    return response.data;
  },

  getActiveTicketsList: async (): Promise<AccountActiveTicketListResponse> => {
    return await EshopCustomerAccountService.eshopCustomerAccountControllerGetAccountActiveTickets();
  },

  removeCustomerAccount: async (): Promise<ApiResponse> => {
    return await EshopCustomerAccountService.eshopCustomerAccountControllerRemoveCustomerAccount();
  },

  getCustomerAccountCartLifetime: async (): Promise<AccountCartLifetimeResponse> => {
    return await EshopCustomerAccountService.eshopCustomerAccountControllerGetCustomerCartLifeTime();
  },

  nullCustomerAccountCartLifeTime: async (): Promise<void> => {
    return await EshopCustomerAccountService.eshopCustomerAccountControllerNullCustomerCartLifetime();
  },

  changeChildAccountToRegularAccount: async (): Promise<void> => {
    await EshopCustomerAccountService.eshopCustomerAccountControllerChangeChildAccountToRegularAccount();
  },
  isEmailUsed: async (email: string): Promise<boolean> => {
    const response = await EshopCustomerAccountService.eshopCustomerAccountControllerVerifyEmailExists({ email });
    return response.data;
  },
};
